// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var MediaCollectionName_Enum;
(function (MediaCollectionName_Enum) {
    MediaCollectionName_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    MediaCollectionName_Enum["TEST_COLLECTION"] = "TEST_COLLECTION";
    MediaCollectionName_Enum["IMAGE_GALLERY"] = "IMAGE_GALLERY";
    MediaCollectionName_Enum["EMAIL_MARKETING_ASSETS"] = "EMAIL_MARKETING_ASSETS";
    MediaCollectionName_Enum["STATIC_ASSETS"] = "STATIC_ASSETS";
})(MediaCollectionName_Enum || (MediaCollectionName_Enum = {}));
export var MediaCollectionName_Enum_index;
(function (MediaCollectionName_Enum_index) {
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["TEST_COLLECTION"] = 1] = "TEST_COLLECTION";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["IMAGE_GALLERY"] = 2] = "IMAGE_GALLERY";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["EMAIL_MARKETING_ASSETS"] = 3] = "EMAIL_MARKETING_ASSETS";
    MediaCollectionName_Enum_index[MediaCollectionName_Enum_index["STATIC_ASSETS"] = 4] = "STATIC_ASSETS";
})(MediaCollectionName_Enum_index || (MediaCollectionName_Enum_index = {}));
/**
 * PublicMedia provides a place for products/services to store media assets (images, etc.) that should be _publicly_ available. Media assets uploaded
 * to this service will be accessible to any user on the internet who has the URL, so think carefully about your use-case before putting media here.
 * There is a rest/grpc api for listing/retrieving media assets, and a separate multipart form upload endpoint for actually uploading media. See
 * github.com/weave-lab/messaging-media-public for more information on how to interact with this service.
 */
export const PublicMedia = {
    /**
     * ListCollections returns a list of media collections that have been enabled on the server. It is not expected that other services or UIs will
     * need to call this method, but it is available for debugging and discovery purposes.
     */
    ListCollections(fn, req) {
        return fn(`/messaging/media/public/v1/collections?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListMedia is only valid for collections where asset creation is enabled. It will return a paginated list of media items within the collection.
     */
    ListMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/public/v1/collections/${req["collectionName"]}/media?${fm.renderURLSearchParams(req, ["collectionName"])}`, { method: "GET" });
    },
    /**
     * GetMedia returns a single media item from the specified collection.
     */
    GetMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
            fm.validateUrlParam(req["mediaId"], "mediaId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/public/v1/collections/${req["collectionName"]}/media/${req["mediaId"]}?${fm.renderURLSearchParams(req, ["collectionName", "mediaId"])}`, { method: "GET" });
    },
    /**
     * DeleteMedia will delete the specified media item. This should be considered a destructive operation that cannot be undone.
     */
    DeleteMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
            fm.validateUrlParam(req["mediaId"], "mediaId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/public/v1/collections/${req["collectionName"]}/media/${req["mediaId"]}?${fm.renderURLSearchParams(req, ["collectionName", "mediaId"])}`, { method: "DELETE" });
    },
    /**
     * ListSystemMedia does the same thing as ListMedia, but it automatically populates the org_id and business_group_ids fields in the request with the system location.
     */
    ListSystemMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/public/v1/system/collections/${req["collectionName"]}/media?${fm.renderURLSearchParams(req, ["collectionName"])}`, { method: "GET" });
    },
    /**
     * GetSystemMedia does the same thing as GetMedia, but it automatically populates the org_id field in the request with the system location.
     */
    GetSystemMedia(fn, req) {
        try {
            fm.validateUrlParam(req["collectionName"], "collectionName");
            fm.validateUrlParam(req["mediaId"], "mediaId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/media/public/v1/system/collections/${req["collectionName"]}/media/${req["mediaId"]}?${fm.renderURLSearchParams(req, ["collectionName", "mediaId"])}`, { method: "GET" });
    },
};
